import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAuthenticated, setToken } from "../../Reducer/AuthReducer";
import "./AuthenticationLayout.css";

type AuthenticationLayoutProps = {
  clientConfig: any;
  children: React.ReactNode;
};

export const AuthenticationLayout = ({
  children,
}: AuthenticationLayoutProps) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  useEffect(() => {
    if (token && isAuthenticated) {
      dispatch(setToken(token));
      dispatch(setAuthenticated(true));
    }
  }, [token, isAuthenticated, dispatch]);

  return (
    <div className="AuthenticationLayout">
      {children}
    </div>
  );
};